<mat-toolbar>
  <app-admin-console class='minimized'></app-admin-console>
</mat-toolbar>

<ng-template *ngIf='messages.length > 0'>
  <span>{{messages[this.index - 1]}}</span>

  <div fxLayout='row' fxLayoutAlign='center center' fxLayoutGap='10px'>
    <button mat-icon-button (click)='previous()'>
      <mat-icon>chevron_left</mat-icon>
    </button>

    <span>{{index}} / {{messages.length}}</span>

    <button mat-icon-button (click)='next()'>
      <mat-icon>chevron_right</mat-icon>
    </button>

    <button mat-icon-button (click)='empty()'>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</ng-template>
